import { createAsyncThunk } from '@reduxjs/toolkit';
import { Context } from '@wix/wix-chatbot-common/browser';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { chatbotStartChat } from '../api/chatbotStartChat';
import { TRootState } from '../reducers';

export type StartChatParams = Record<string, string>;

export const loadChatbotStartChat = createAsyncThunk<IInitialChatData, Context, { state: TRootState }>(
  'loadChatbotStartChat',
  async (context: Context, { getState }) => {
    const state = getState();
    // priority of what parameters send to start chat request:
    // 1. use params we set manually to the state(for example, when user click on Report A Bug)
    // 2. use widgetSDK to fetch Start Chat Params(from widget script or href if widget script is not available)
    const startChatParams = state.chat.startChatParameters || (await widgetSDK.getStartChatParams());
    return chatbotStartChat(startChatParams, context);
  },
);
